import { useEffect, useState } from "react"
import "./Announcements.scss"
import opsImage from "../../assets/announcements/ops.JPG"
import rozpoczecieImage from "../../assets/announcements/rozpoczecie2026.jpeg"

const announcements = [
	{
		id: 1,
		title: "Pomoc materialna",
		date: "15 września",
		time: "24:00",
		image: opsImage,
		urgent: true,
		description: (
			<>
				<p>
					Od dnia 1 września 2026 r. w Ośrodku Pomocy Społecznej w Dzierzoniowie
					będzie prowadzony nabór wniosków o przyznanie stypendium socjalnego
					dla uczniów znajdujących się w trudnej sytuacji materialnej.
				</p>

				<p>Szczególy w pismie</p>
			</>
		),
	},
	{
		id: 2,
		title: "Rozpoczęcie roku szkolnego",
		date: "1 września",
		time: "9:00",
		image: rozpoczecieImage,
		urgent: false,
	},
]

export const Announcements = () => {
	const [active, setActive] = useState(0)
	const [paused, setPaused] = useState(false)

	const nextSlide = () => {
		setActive(current => (current + 1) % announcements.length)
	}

	const previousSlide = () => {
		setActive(
			current => (current - 1 + announcements.length) % announcements.length,
		)
	}

	useEffect(() => {
		if (paused) return

		const interval = setInterval(() => {
			nextSlide()
		}, 6500)

		return () => clearInterval(interval)
	}, [paused])

	return (
		<section
			className='announcements'
			aria-label='Ważne ogłoszenia'
			onMouseEnter={() => setPaused(true)}
			onMouseLeave={() => setPaused(false)}>
			<div className='announcements__container'>
				<div className='announcements__heading'>
					<div>
						<span className='announcements__eyebrow'>Ogłoszenia szkoły</span>

						<h2>Ważne ogłoszenia</h2>
					</div>

					<div className='announcements__heading-line' />
				</div>

				<div className='announcements__slider'>
					{announcements.map((announcement, index) => (
						<article
							key={announcement.id}
							className={`announcement ${
								index === active ? "announcement--active" : ""
							}`}
							aria-hidden={index !== active}>
							<div className='announcement__image-wrapper'>
								<img
									src={announcement.image}
									alt={announcement.title}
									className='announcement__image'
								/>

								{announcement.urgent && (
									<span className='announcement__badge'>
										Ważne dla rodziców
									</span>
								)}
							</div>

							<div className='announcement__content'>
								<span className='announcement__label'>
									{announcement.urgent ? "Ważne" : "Zapraszamy"}
								</span>

								<h3>{announcement.title}</h3>

								<div className='announcement__details'>
									<div>
										<span>📅</span>
										<strong>{announcement.date}</strong>
									</div>

									<div>
										<span>🕘</span>
										<strong>godz. {announcement.time}</strong>
									</div>
								</div>

								{announcement.description && (
									<div className='announcement__description'>
										{announcement.description}
									</div>
								)}

								<button
									type='button'
									className='announcement__button'
									onClick={() => setActive(index)}>
									Zobacz ogłoszenie
									<span aria-hidden='true'>→</span>
								</button>
							</div>
						</article>
					))}

					<button
						type='button'
						className='announcement__arrow announcement__arrow--prev'
						onClick={previousSlide}
						aria-label='Poprzednie ogłoszenie'>
						‹
					</button>

					<button
						type='button'
						className='announcement__arrow announcement__arrow--next'
						onClick={nextSlide}
						aria-label='Następne ogłoszenie'>
						›
					</button>
				</div>

				<div className='announcements__navigation'>
					<div className='announcements__dots'>
						{announcements.map((announcement, index) => (
							<button
								key={announcement.id}
								type='button'
								className={`announcement__dot ${
									index === active ? "announcement__dot--active" : ""
								}`}
								onClick={() => setActive(index)}
								aria-label={`Pokaż ogłoszenie ${index + 1}`}
								aria-current={index === active}></button>
						))}
					</div>

					<span className='announcements__counter'>
						{String(active + 1).padStart(2, "0")} /{" "}
						{String(announcements.length).padStart(2, "0")}
					</span>
				</div>
			</div>
		</section>
	)
}
